module.exports = __webpack_public_path__ + "img/9.9e318536.svg";